/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'antd';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

// import EditProfileNav from './sections/EditProfileNav';
import EditProfileForm from './sections/EditProfileForm';
import formLayout from '../Layout/formLayout';


const EditProfile = () => {
    const navigate = useNavigate();
    // const currentChefStep = useSelector(state => state.auth.user.step);
    const currentChefStep = useSelector(state => state.profile.currentChefStep);

    useEffect(() => {
        if(currentChefStep === 3){
            navigate('/profile');
        }
    }, [currentChefStep])

    const steps = [
        'Basic Information',
        'Service Details',
        'Photos & Images',
    ];

    return(
        <>
            {/* <EditProfileNav /> */}
            <Row className='w-full sm:min-h-full sm:h-auto sm:flex-col  sm:items-center bg-neutral-100'>
                <Col className='w-full bg-white rounded-md 2xl:w-3/12 xl:w-4/12 lg:w-4/12 md:w-5/12 sm:w-6/12 sm:px-3 sm:my-4' style={{    minHeight: "100vh"}}>
                    
                    <Row className='w-full flex justify-center my-4 ml-2 px-4'>
                        <h1 className='text-xl font-medium' style={{ fontFamily: 'OnestSemibold'}}>Edit Your Profile</h1>
                    </Row>

                    <Row className='sm:w-full my-3 py-2 ml-2 px-4' style={{ margin: '0 auto'}}>
                        <Box sx={{ width: '100%' }}>
                        <Stepper 
                            activeStep={ currentChefStep === 0 ? 0 : currentChefStep === 1 ? 1 : 2 } 
                            alternativeLabel>

                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        </Box>
                    </Row>
                    
                    <EditProfileForm />
                </Col>
            </Row>
        </>
    );
}

export default formLayout(EditProfile);